import createPersistedState from "vuex-persistedstate";
import { supabase } from "@/auth/supabase";
import router from "@/routes/index";

export default {
  namespaced: true,
  state: {
    user: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
  },
  actions: {
    async signInAction({ commit }, form) {
      try {
        const { error, user } = await supabase.auth.signIn({
          email: form.email,
          password: form.password,
        });
        if (error) throw error;
        commit('setUser', user.email)

        await router.push('/')
      } catch (error) {
        alert(error.error_description || error.message);

        return {
          error,
        }
      }
    },

    async signOutAction({ commit }) {
      try {
        const { error } = await supabase.auth.signOut();
        if (error) throw error;
        commit('setUser', null)
    
        await router.push('/sign-in')
      } catch (error) {
        alert(error.error_description || error.message);

        return {
          error
        }
      }
    },
  },
  plugins: [createPersistedState()]
};